module.exports = __webpack_public_path__ + "static/media/5.6b7e4055.png";